import { Link } from "@reach/router";
import React, { useState } from "react";
import simboloBlanco from "../../assets/rebrand/simbolo-blanco.png";
import simboloPrimary from "../../assets/rebrand/simbolo-primary.png";

const MobileNavbar = ({ branch_id }) => {
  const [display, setDisplay] = useState(false);

  const handleClickTab = () => {
    setDisplay(false);
  };

  return (
    <nav className="navbar navbar-expand-lg monterrey-navbar navbar-light  show-mobile mx-auto start-0 end-0">
      <div className="container-fluid px-0 navbar-container">
        <a className="navbar-brand p-2 ps-0" href="/#landing">
          <img
            src={simboloBlanco}
            style={{ width: "75px", height: "75px", objectFit: "contain" }}
            alt="The Body Method"
          />
        </a>
        <button
          className="navbar-toggler rounded-0"
          type="button"
          onClick={() => setDisplay(!display)}
          style={{
            backgroundColor: "transparent !important",
            borderWidth: "0px !important",
            border: "none !important",
          }}
        >
          <i className="fa fa-bars text-white" style={{ fontSize: "20px" }} />
        </button>

        <div
          className="bg-light w-100 vh-100 drawer-menu overflow-hidden"
          style={{
            position: "fixed",
            top: "0",
            left: display ? 0 : "-100vw",
          }}
        >
          <div className="container-fluid px-2 px-md-3 pe-md-5">
            <div className="row justify-content-between align-items-center w-100 mx-auto">
              <a
                className="navbar-brand p-2 ps-0 w-max-content"
                href="/#landing"
              >
                <img
                  src={simboloPrimary}
                  style={{ width: "73px", height: "73px" }}
                />
              </a>

              <button
                className="navbar-toggler rounded-0"
                type="button"
                onClick={() => setDisplay(!display)}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>

            <ul
              className="navbar-nav nav justify-content-center position-relative"
              style={{ paddingRight: "130px" }}
            >
              <li className="nav-item">
                <a className="nav-link" href="/rewards/">
                  Rewards
                </a>
              </li>
              <li className={`nav-item `}>
                <a
                  onClick={handleClickTab}
                  className="nav-link"
                  href="#scrollspyAbout"
                >
                  Sobre Nosotros
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={handleClickTab}
                  className="nav-link"
                  href="#scrollspyMtyClassTypes"
                >
                  Método
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={handleClickTab}
                  className="nav-link"
                  href="#scrollspyMtyCoaches"
                >
                  Coaches
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={handleClickTab}
                  className="nav-link"
                  href="#scrollspyMtyPackages"
                >
                  Paquetes
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={handleClickTab}
                  className="nav-link"
                  href="#scrollspyMtyLocations"
                >
                  Studio
                </a>
              </li>

              <li className="navbar-cta__container ms-md-3 position-absolute end-0 bottom-0 top-0">
                <Link
                  className={`btn monterrey-landing__cta bold text-uppercase ${branch_id === 2 ? "bg-gradient-landing--tijuana text-dark" : "bg-gradient-landing text-white"}`}
                  to="/entrar"
                >
                  <i className="fa fa-user"></i>{" "}
                  <span className="ms-1">Ingresar</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MobileNavbar;
